import type { CreateSnapshotInput, QuoteSnapshot, SnapshotItem } from './types'

export class SnapshotValidator {
  validateCreateInput(input: CreateSnapshotInput): string[] {
    const errors: string[] = []
    if (!input.quoteId) errors.push('quoteId é obrigatório')
    if (!input.quoteCode) errors.push('quoteCode é obrigatório')
    if (![3, 5, 7, 15, 30].includes(input.validUntilDays)) {
      errors.push('Validade inválida')
    }
    if (!Array.isArray(input.items)) errors.push('items é obrigatório')
    return errors
  }

  validateSnapshot(snapshot: QuoteSnapshot): string[] {
    const errors: string[] = []
    if (!snapshot.id) errors.push('id ausente')
    if (!snapshot.quoteId) errors.push('quoteId ausente')
    if (snapshot.version < 1) errors.push('versão inválida')
    if (!snapshot.items) errors.push('items ausente')
    for (const item of snapshot.items ?? []) {
      errors.push(...this.validateItem(item))
    }
    return errors
  }

  validateItem(item: SnapshotItem): string[] {
    const errors: string[] = []
    if (!item.id) errors.push('item.id ausente')
    if (!item.description?.trim()) errors.push('item.description ausente')
    if (item.quantity < 1) errors.push(`quantidade inválida: ${item.description}`)
    if (item.purchasePrice < 0 || item.salePrice < 0) {
      errors.push(`preço inválido: ${item.description}`)
    }
    return errors
  }

  validateImportPayload(payload: unknown): { ok: true; data: QuoteSnapshot } | { ok: false; errors: string[] } {
    if (!payload || typeof payload !== 'object') {
      return { ok: false, errors: ['Payload inválido'] }
    }
    const root = payload as Record<string, unknown>
    const snapshot =
      root.snapshot && typeof root.snapshot === 'object'
        ? (root.snapshot as QuoteSnapshot)
        : (root as unknown as QuoteSnapshot)

    const errors = this.validateSnapshot(snapshot)
    if (errors.length > 0) return { ok: false, errors }
    return { ok: true, data: snapshot }
  }

  assertCanMutate(snapshot: QuoteSnapshot): void {
    if (snapshot.lockedPrice) {
      throw new Error('Snapshot com preço travado — alterações bloqueadas')
    }
    if (snapshot.status === 'LOCKED') {
      throw new Error('Snapshot bloqueado')
    }
  }
}
